import { BackendModel, BackendService } from '../../core/backend.service';

export class MotivosRechazo extends BackendModel {

  static path = '/pedidos/motivosrechazos/';

  id: number;
  description: string;

  constructor(protected backendService: BackendService, model?: MotivosRechazo) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/motivosRechazo/motivosRechazo.model.ts